export const language = navigator.language.split(/[-_]/)[0];